var map = {
	"./  .svg": 42936,
	"./add-file.svg": 27220,
	"./arrow-forward.svg": 29811,
	"./arrow-right.svg": 91178,
	"./auth-arrow-down.svg": 33519,
	"./auth-dialog-close.svg": 6188,
	"./auth-lock.svg": 72074,
	"./back.svg": 47585,
	"./close.svg": 72300,
	"./cloud-apk.svg": 46006,
	"./cloud-audio.svg": 25314,
	"./cloud-auth-manage.svg": 87442,
	"./cloud-auth-share.svg": 90136,
	"./cloud-click.svg": 43636,
	"./cloud-code.svg": 89651,
	"./cloud-doc.svg": 8334,
	"./cloud-empty.svg": 96071,
	"./cloud-exe.svg": 26644,
	"./cloud-file-delete.svg": 17254,
	"./cloud-folder.svg": 20904,
	"./cloud-fullscreen.svg": 94991,
	"./cloud-home-close-icon.svg": 25780,
	"./cloud-home-open.svg": 14390,
	"./cloud-html.svg": 98355,
	"./cloud-http.svg": 8796,
	"./cloud-icon.svg": 24199,
	"./cloud-image.svg": 82099,
	"./cloud-ipa.svg": 80932,
	"./cloud-markdown.svg": 2559,
	"./cloud-online-doc.svg": 65552,
	"./cloud-online-upload.svg": 63409,
	"./cloud-other-file.svg": 31533,
	"./cloud-other.svg": 78410,
	"./cloud-pdf.svg": 11118,
	"./cloud-ppt.svg": 5816,
	"./cloud-rp.svg": 1418,
	"./cloud-sketch.svg": 75320,
	"./cloud-sort-check.svg": 82027,
	"./cloud-template-brand.svg": 43238,
	"./cloud-ttf.svg": 1026,
	"./cloud-txt.svg": 2012,
	"./cloud-video.svg": 9621,
	"./cloud-wiki-sort.svg": 64349,
	"./cloud-wiki-top-grey.svg": 66494,
	"./cloud-wiki-top.svg": 23522,
	"./cloud-wiki-untop.svg": 47233,
	"./cloud-wiki.svg": 67184,
	"./cloud-xls.svg": 28067,
	"./cloud-zip.svg": 64481,
	"./collapse-back.svg": 84207,
	"./collapse-icon.svg": 79825,
	"./dir_expand.svg": 95752,
	"./download.svg": 40264,
	"./edit-read-mode.svg": 54335,
	"./edit-setting.svg": 75379,
	"./edit-write-mode.svg": 99146,
	"./email_tag_close.svg": 93088,
	"./email_tag_close_hover.svg": 62399,
	"./error-load.svg": 29023,
	"./feedback-contact.svg": 28274,
	"./feedback-report.svg": 23412,
	"./file-apply-auth.svg": 99980,
	"./file-close.svg": 90181,
	"./file-copy.svg": 66144,
	"./file-deleted.svg": 86762,
	"./file-doc.svg": 64347,
	"./file-download.svg": 44383,
	"./file-enter.svg": 58707,
	"./file-excel.svg": 92804,
	"./file-expired.svg": 86402,
	"./file-export.svg": 34205,
	"./file-history.svg": 42441,
	"./file-image.svg": 52442,
	"./file-more.svg": 3212,
	"./file-move.svg": 49784,
	"./file-no-content.svg": 7034,
	"./file-path-more.svg": 87544,
	"./file-path.svg": 25182,
	"./file-pdf.svg": 89659,
	"./file-ppt.svg": 17821,
	"./file-print.svg": 78260,
	"./file-save.svg": 69516,
	"./file-transfer-close.svg": 41585,
	"./file-transfer-delete-no-hover.svg": 99719,
	"./file-transfer-delete.svg": 67862,
	"./file-transfer-input-clear.svg": 8633,
	"./file-transfer-search-no-data.svg": 44078,
	"./file-transfer.svg": 60886,
	"./file-upload-down.svg": 32481,
	"./file-upload.svg": 15200,
	"./file-warning.svg": 69801,
	"./file-wps.svg": 36533,
	"./file_operate.svg": 43323,
	"./file_star.svg": 51469,
	"./file_unstar.svg": 6924,
	"./file_visit.svg": 32426,
	"./folder-upload.svg": 95058,
	"./greyStar.svg": 67197,
	"./greyTips.svg": 28695,
	"./header-search.svg": 42700,
	"./home-create.svg": 10414,
	"./home-select.svg": 39626,
	"./home.svg": 68717,
	"./icon-album-list-loading.svg": 55593,
	"./icon-file-current.svg": 77126,
	"./icon-file-download.svg": 77635,
	"./icon-file-excel.svg": 3840,
	"./icon-file-ppt.svg": 9545,
	"./icon-file-recent.svg": 68106,
	"./icon-file-word.svg": 59431,
	"./lang.svg": 69604,
	"./lang_current.svg": 27610,
	"./lang_icon.svg": 97900,
	"./lang_right_arrow.svg": 35821,
	"./loading.svg": 67428,
	"./mobile-arrow-right.svg": 63707,
	"./mobile-menu-close.svg": 76937,
	"./mobile-menu.svg": 18910,
	"./my-select.svg": 43247,
	"./my.svg": 33598,
	"./phone.svg": 21255,
	"./rateIcon.svg": 2629,
	"./read-arrow-down.svg": 96137,
	"./read-arrow-up.svg": 63782,
	"./recent_item_kb.svg": 14975,
	"./recent_type_home.svg": 33782,
	"./recent_type_kb.svg": 26412,
	"./recent_type_mine.svg": 68334,
	"./recent_type_star.svg": 3479,
	"./refresh.svg": 22305,
	"./share-add-member.svg": 18402,
	"./share.svg": 66497,
	"./sign-out.svg": 28816,
	"./star-select.svg": 71373,
	"./star.svg": 12120,
	"./template_brand.svg": 40064,
	"./template_brand_gray.svg": 14798,
	"./template_mark.svg": 11566,
	"./template_mark_en.svg": 47528,
	"./toca.svg": 12271,
	"./upload-close.svg": 77392,
	"./upload-done.svg": 73004,
	"./upload-down.svg": 93848,
	"./upload-ing.svg": 17356,
	"./upload-mission-close.svg": 62625,
	"./upload-open.svg": 82796,
	"./upload-pause.svg": 72610,
	"./upload-replay.svg": 2825,
	"./upload-start.svg": 24608,
	"./upload-up.svg": 11595,
	"./user.svg": 15289,
	"./wiki-select.svg": 75385,
	"./wiki.svg": 19380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15111;